import { useBuildVars } from 'src/config';

export function useIsEnvironment() {
  const buildvars = useBuildVars();

  const isProdEnvironment = buildvars.ENV_TYPE === 'production';
  const isBetaXEnvironment = buildvars.ENV_TYPE === 'productionbetax';
  const isBetaEnvironment = buildvars.ENV_TYPE === 'productionbeta';
  const isQAEnvironment = ['staging', 'staging2'].includes(buildvars.ENV_TYPE);
  const isTestEnvironment = buildvars.ENV_TYPE === 'test';
  const isDevEnvironment = buildvars.ENV_TYPE === 'development';

  return {
    isBetaEnvironment,
    isBetaXEnvironment,
    isDevEnvironment,
    isProdEnvironment,
    isQAEnvironment,
    isTestEnvironment,
  };
}
